var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrawerLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.00016C2.25 3.57516 3.40833 2.41683 4.83333 2.41683H8.16667V0.833496H4.83333C2.53333 0.833496 0.666668 2.70016 0.666668 5.00016C0.666668 7.30016 2.53333 9.16683 4.83333 9.16683H8.16667V7.5835H4.83333C3.40833 7.5835 2.25 6.42516 2.25 5.00016ZM5.66667 5.8335H12.3333V4.16683H5.66667V5.8335ZM13.1667 0.833496H9.83333V2.41683H13.1667C14.5917 2.41683 15.75 3.57516 15.75 5.00016C15.75 6.42516 14.5917 7.5835 13.1667 7.5835H9.83333V9.16683H13.1667C15.4667 9.16683 17.3333 7.30016 17.3333 5.00016C17.3333 2.70016 15.4667 0.833496 13.1667 0.833496Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.00016C2.25 3.57516 3.40833 2.41683 4.83333 2.41683H8.16667V0.833496H4.83333C2.53333 0.833496 0.666668 2.70016 0.666668 5.00016C0.666668 7.30016 2.53333 9.16683 4.83333 9.16683H8.16667V7.5835H4.83333C3.40833 7.5835 2.25 6.42516 2.25 5.00016ZM5.66667 5.8335H12.3333V4.16683H5.66667V5.8335ZM13.1667 0.833496H9.83333V2.41683H13.1667C14.5917 2.41683 15.75 3.57516 15.75 5.00016C15.75 6.42516 14.5917 7.5835 13.1667 7.5835H9.83333V9.16683H13.1667C15.4667 9.16683 17.3333 7.30016 17.3333 5.00016C17.3333 2.70016 15.4667 0.833496 13.1667 0.833496Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawerLink);
export default __webpack_public_path__ + "static/media/iconDrawerLink.1b2493764a8d3c792e833ca65dbadc6c.svg";
export { ForwardRef as ReactComponent };